export const AWS_USER_TEMP_PREFIX = 'user-content-temp';
export const AWS_USER_PREFIX = 'user-content';
